module.exports = __webpack_public_path__ + "img/RIREKI_DIAMOND.44cd274d.png";